export var EntityType;
(function (EntityType) {
    EntityType["URL"] = "URL";
    EntityType["SOFTWARE"] = "SOFTWARE";
    EntityType["MALWARE"] = "MALWARE";
    EntityType["CVE"] = "CVE";
    EntityType["SHA256"] = "SHA256";
    EntityType["SHA1"] = "SHA1";
    EntityType["MD5"] = "MD5";
    EntityType["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    EntityType["REGISTRY_KEY"] = "REGISTRY_KEY";
    EntityType["IP"] = "IP";
    EntityType["DATE"] = "DATE";
    EntityType["BITCOIN_ADDRESS"] = "BITCOIN_ADDRESS";
    EntityType["CIDR_BLOCK"] = "CIDR_BLOCK";
    EntityType["PHONE_NUMBER"] = "PHONE_NUMBER";
    EntityType["X_ID"] = "X_ID";
    EntityType["THREAT_ACTOR"] = "THREAT_ACTOR";
})(EntityType || (EntityType = {}));
